import { createQueryKeys } from '@lukemorales/query-key-factory'

export const portfolio = createQueryKeys('portfolio', {
  all: null,
  detail: (id: string) => [id],
  search: (query: string) => ['search', query],
  valueChart: null,
})

